var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Wpłaty: "+_vm._s(_vm._f("currency")(_vm.payIn)))]),_c('div',[_vm._v("Wydatki: "+_vm._s(_vm._f("currency")(_vm.payOut)))]),_c('div',[_vm._v("Oszczędności: "+_vm._s(_vm._f("currency")(_vm.savings)))])])}
var staticRenderFns = []

export { render, staticRenderFns }